import { render, staticRenderFns } from "./PortalLetterStep.vue?vue&type=template&id=54a385a6&scoped=true"
import script from "./PortalLetterStep.vue?vue&type=script&lang=js"
export * from "./PortalLetterStep.vue?vue&type=script&lang=js"
import style0 from "./PortalLetterStep.vue?vue&type=style&index=0&id=54a385a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a385a6",
  null
  
)

export default component.exports